import { Link } from '@reach/router';
import React, { useContext } from 'react';
import { NotebookContext } from '../../../context/NotebookContext';
import client from '../../../lib/client';
import { deleteNoteMutation, notesQuery } from '../../../queries/notes';
import {
  NoteDeleteMutation,
  NoteDeleteMutationVariables
} from '../../../queries/__generated__/NoteDeleteMutation';
import { ButtonIconRound, Card, CardSegment } from '../../ui';
import MeasurementsBySubject from './MeasurementsBySubject';

interface DataCardProps {
  note: {
    id: string;
    measurements: {
      subject: {
        id: string;
      };
      tracker: {
        id: string;
      };
      value: number;
    }[];
    subjects: {
      id: string;
      name: string;
    }[];
  };
  isEntryAuthor: boolean;
}

const DataCardSmall: React.FC<DataCardProps> = ({ note }) => {
  return (
    <div data-testid="entry-data-card">
      <Link
        to={`/notebook/note/${note.id}`}
        key={note.id}
        className="db navy tl mb2"
        data-testid="note"
      >
        <CardSegment>
          <MeasurementsBySubject measurements={note.measurements} subjects={note.subjects} />
        </CardSegment>
      </Link>
    </div>
  );
};

const DataCardNotSmall: React.FC<DataCardProps> = ({ note, isEntryAuthor }) => {
  const {notebook} = useContext(NotebookContext);

  async function deleteNote() {
    const confirmDelete = confirm('Are you sure you want to delete this note?');
    if (confirmDelete) {
      await client
        .mutate<NoteDeleteMutation, NoteDeleteMutationVariables>({
          mutation: deleteNoteMutation,
          variables: { input: { id: note.id } },
          awaitRefetchQueries: true,
          refetchQueries: [
            {
              query: notesQuery,
              variables: { input: { notebookId: notebook.id, first: 20 } }
            }
          ]
        })
        .then(data => {
          console.log(data);
          const { errors } = data;
          if (errors) {
            throw new Error(errors[0].message);
          }
        });
    }
  }

  return (
    <div className="hide-child" data-testid="entry-data-card">
      <Link
        to={`/notebook/note/${note.id}`}
        key={note.id}
        className="db navy tl mb2"
        data-testid="note"
      >
        <Card>
          <CardSegment className="pt3 pb4">
            <MeasurementsBySubject measurements={note.measurements} subjects={note.subjects} />
          </CardSegment>
        </Card>
      </Link>

      {isEntryAuthor && (
        <div className="child dn db-ns">
          <div className="flex items-center">
            <ButtonIconRound
              as={Link}
              to={`/notebook/note/${note.id}/edit`}
              name="edit"
              iconSize={20}
              className="mr2"
              data-testid="edit-entry-button"
            />
            <ButtonIconRound
              onClick={deleteNote}
              name="trash"
              iconSize={20}
              data-testid="delete-entry-button"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export { DataCardSmall, DataCardNotSmall };
